//========= LOADER  ========//


const loaderWrapper = document.getElementById('tr__loader-wrapper');

// Function to animate counter from start to target number
function animateCounter(start, target, duration, startTranslateY, endTranslateY) {
    let current = start;
    const counter = document.getElementById('tr__loader-counter');
    const counterTextWrapper = document.getElementById('tr__loader-text-container');
    const counterSpan = document.getElementById('tr__loader-counter-span');
    const step = Math.ceil((target - start) / (duration / 16)); // Adjust speed by changing the divisor
    const interval = setInterval(() => {
        current += step;
        counterSpan.textContent = current;
        if ((step > 0 && current >= target) || (step < 0 && current <= target)) {
            clearInterval(interval);
        }
        // Calculate the new translateY value based on the current value and viewport height

        const translateY = `calc(${startTranslateY})`;
        counter.style.transition = 'transform 1.5s ease';
        counterTextWrapper.style.transition = 'transform 1.5s ease';
        counter.style.transform = `translateY(${translateY})`;
        counterTextWrapper.style.transform = `translateY(${translateY})`;
    }, 16);
}





loaderWrapper.style.opacity = 1;
  
function swapText() {
const word1 = document.getElementById('word1');
const word2 = document.getElementById('word2');

// Swap words
word1.classList.add('-translate-y-full', 'opacity-0');
word2.classList.remove('opacity-0');
word2.classList.remove('translate-y-full');
}

function swapText2() {
const word1 = document.getElementById('word1');
const word2 = document.getElementById('word2');
const word3 = document.getElementById('word3');

// Swap words
word2.classList.add('-translate-y-full', 'opacity-0');
word3.classList.remove('opacity-0');
word3.classList.remove('translate-y-full');
}
  



// Call the first animation to move lines to the center of the viewport
setTimeout(() => {
    animateCounter(0, 50, 2000, '-50vh + 50%', '-100vh + 100%'); // 2000ms duration for the first animation
}, 200);


// After a delay of 100ms, call the swapText function
setTimeout(() => {
    swapText();
    }, 2200);


// Call the second animation to move lines to the top of the viewport
setTimeout(() => {
    animateCounter(50, 100, 2000, '-96vh + 100%', '-50vh + 50%'); // 2000ms duration for the second animation
}, 3500);




setTimeout(() => {
    swapText2();
    }, 5000);
  
  



setTimeout(function() {
var loader = document.getElementById("tr-loader");
loader.style.opacity = "0";


setTimeout(function() {
    loader.style.display = "none"; //match it with the animation timing for loader
}, 1000); 
}, 6600); 
  
 